import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { ParentsOnboardingBatchesByIdTable } from '~pages/parents/csv-batch-processing/id/parents-onboarding-batches-by-id-table';

interface ParentOnboardingBatchesByIdPageProps {
  batchId: string;
}

export const ParentOnboardingBatchesByIdPage = ({
  batchId,
}: ParentOnboardingBatchesByIdPageProps) => {
  return (
    <div className='pt-4'>
      <Link
        className='mb-8 flex w-fit items-center gap-2'
        to='/parents/csv-batch-processing'
      >
        <CircleArrowLeft className='size-6' />
        <span className='text-lg font-semibold'>Back</span>
      </Link>

      <div className='border-t px-4 pt-8'>
        <ParentsOnboardingBatchesByIdTable batchId={batchId} />
      </div>
    </div>
  );
};
